var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radio"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.37504,
    y: 0.683757,
    width: 19.25,
    height: 19.25,
    rx: 9.625,
    fill: "#7DF8A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.37504,
    y: 0.683757,
    width: 19.25,
    height: 19.25,
    rx: 9.625,
    stroke: "#292829",
    strokeWidth: 0.916667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7104 6.75059L15.7093 6.75155L9.48263 12.2407L6.69841 9.78622C6.69835 9.78617 6.6983 9.78612 6.69823 9.78606C6.61756 9.71444 6.50778 9.67415 6.39328 9.67415C6.27874 9.67415 6.16895 9.71445 6.08826 9.7861C6.08822 9.78615 6.08818 9.78618 6.08813 9.78622L5.62712 10.1926C5.62707 10.1927 5.627 10.1927 5.62695 10.1928C5.54569 10.2639 5.5 10.3607 5.5 10.4616C5.5 10.5626 5.54572 10.6594 5.627 10.7305C5.62704 10.7305 5.62708 10.7306 5.62712 10.7306L9.18079 13.8634C9.18085 13.8634 9.18093 13.8634 9.18099 13.8635C9.26167 13.9351 9.37143 13.9754 9.48593 13.9754C9.60043 13.9754 9.71019 13.9351 9.79087 13.8635C9.79093 13.8634 9.791 13.8634 9.79107 13.8634L16.7803 7.702C16.7803 7.70198 16.7804 7.70196 16.7804 7.70194C16.8617 7.63081 16.9074 7.534 16.9074 7.43301C16.9074 7.33215 16.8618 7.23546 16.7807 7.16436C16.7805 7.16424 16.7804 7.16413 16.7803 7.16401L16.3195 6.75198V6.75197L16.3179 6.75059C16.1486 6.60592 15.8796 6.60592 15.7104 6.75059Z",
    fill: "#292829",
    stroke: "#292829",
    strokeWidth: 0.183333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreenIcon);
export default __webpack_public_path__ + "static/media/check-circle-green-icon.d8d52971795c9f583dd201fc5b7e3f3f.svg";
export { ForwardRef as ReactComponent };